import React, { Component } from 'react';
import editNote from '../../resources/images/estrategas/tools/edit.svg'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import * as Request from '../../service/data-info-chart/requestsUtil';
import { NEW_BUSINESS_NOTE } from '../../utils/constants';


class EditNote extends Component {

  constructor(props) {
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
    this.editNote = this.editNote.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = { modal: false, note: this.props.note.note };
  }

  toggleModal(){
    this.setState({ modal: !this.state.modal });
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  editNote(){

    let params = {
      id: this.props.note.id,
      note: this.state.note,
      registry: this.props.note.registry
    };

    Request.putFetch(NEW_BUSINESS_NOTE, params).then(()=>{
      this.props.callbackFromParent(Math.random());
      this.toggleModal()
    })

  }


  render() {
    let classUser = this.props.authorization ? 'add-notes-icon' : 'quality-edit-unauthorized';
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={this.props.className}>
          <ModalHeader className='header-modal' toggle={this.toggleModal}>Agregar nota</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="note">Editar nota</Label>
              <Input
                type="textarea"
                name="note"
                id="note"
                value={this.state.note}
                onChange={this.handleChange}
                style={{ height: '150px' }}
                maxLength={500}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.editNote}>Guardar</Button>{' '}
            <Button color="danger" onClick={this.toggleModal}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className={classUser} onClick={this.toggleModal}>
          <img src={editNote} title='Editar nota' alt=''/>
        </div>
      </div>
    );
  }
}

export default EditNote;



// WEBPACK FOOTER //
// ./src/components/buttons/editNoteNewBusiness.js